import { useMemo } from "react";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

interface UseZoomShortcutsProps {
  zoomIn: () => void;
  zoomOut: () => void;
  zoomReset: () => void;
  zoomToFit?: () => void;
  zoomToSelection?: () => void;
}

export const useZoomShortcuts = ({
  zoomIn,
  zoomOut,
  zoomReset,
  zoomToFit,
  zoomToSelection,
}: UseZoomShortcutsProps) => {
  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "mod+=": {
        handler: zoomIn,
        description: "Zoom in",
      },
      "mod+-": {
        handler: zoomOut,
        description: "Zoom out",
      },
      "mod+0": {
        handler: zoomReset,
        description: "Reset zoom",
      },
      "shift+=": {
        handler: zoomIn,
        description: "Zoom in",
      },
      "shift+-": {
        handler: zoomOut,
        description: "Zoom out",
      },
      "shift+0": {
        handler: zoomReset,
        description: "Reset zoom",
      },
      "shift+1": {
        handler: () => zoomToFit?.(),
        description: "Zoom to fit",
      },
      "shift+2": {
        handler: () => zoomToSelection?.(),
        description: "Zoom to selection",
      },
    }),
    [zoomIn, zoomOut, zoomReset, zoomToFit, zoomToSelection],
  );

  useKeyboardShortcuts({ shortcuts });
};
